<template>
  <button
    type="button"
    class="flex w-full max-w-[270px] flex-col items-center justify-start rounded-lg bg-transparent px-2.5 py-4 text-center text-sm font-medium transition duration-300 ease-out hover:bg-[#e7f4eb] hover:bg-opacity-30 hover:shadow-[-2px_-3px_0px_#D2DACD] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
    @click="
      $emit('open', {
        event: props.event,
        date: dateFormatted,
      })
    "
  >
    <div
      class="mb-[34px] flex h-full max-h-[91px] w-full max-w-[91px] items-center justify-center laptop:h-[180px] laptop:max-h-full laptop:max-w-[180px]"
    >
      <img
        :src="props.event.attributes?.image?.data?.attributes?.url"
        :alt="props.event.attributes?.image?.data?.attributes?.alternativeText || ''"
        width="172"
        height="172"
        class="h-full max-h-[83px] w-full max-w-[83px] object-contain laptop:max-h-[172px] laptop:max-w-[172px]"
      />
    </div>
    <div class="date pb-2.5">{{ dateFormatted }}</div>
    <div class="description max-w-[217px]">{{ props.event.attributes?.venue }}</div>
  </button>
</template>
<script setup lang="ts">
import { EventInformationFragment } from "#gql";
defineEmits(["open"]);

const props = defineProps<{
  event: EventInformationFragment;
}>();

const dateFormatted = computed(() => {
  const startDate = new Date(props.event.attributes?.startDate);
  const endDate = new Date(props.event.attributes?.endDate);

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const month = startDate.toLocaleString("default", { month: "short" });
  const startDateyear = startDate.getFullYear();
  const endDateYear = endDate.getFullYear();

  if (startDate.getMonth() !== endDate.getMonth() || startDate.getFullYear() !== endDate.getFullYear()) {
    return `${startDay} ${month}  ${
      startDate.getFullYear() !== endDate.getFullYear() ? startDateyear : ""
    } - ${endDay} ${endDate.toLocaleString("default", {
      month: "short",
    })} ${endDateYear}`;
  }

  return `${startDay}-${endDay} ${month} ${endDateYear}`;
});
</script>
<style lang="scss" scoped></style>
